export const useCookieConfig = () => {
  const config = useRuntimeConfig();
  const cookieMaxAgeDays = config.public.sellerCookieMaxAgeDays || 30;
  
  return {
    // Seller-related cookies (club, seller, isSeller, invoiceRejected)
    sellerCookieOptions: {
      maxAge: 3600 * 24 * cookieMaxAgeDays,
      path: '/',
    },
  };
};
